module.exports = __webpack_public_path__ + "static/driveway-380ab4c3001722232c2d41069f56c3c9.jpg";